import { Link, useParams } from 'react-router-dom'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import HomeIcon from '@mui/icons-material/Home'
import { Box, Breadcrumbs, Typography } from '@mui/material'
import styled from 'styled-components'
import FaqSection from '../PrewallAndPaywall/FaqSection'
import PublicAppHeader from '../PublicAppHeader'
import { ClubbedAuthModal } from '../SignIn/ClubbedAuthComponents'
import { useState } from 'react'
import { FAQ_LAYOUTS } from '../PrewallAndPaywall/faqComponents/utils'
import { SEOComponent } from 'src/consumer/helpers/utilFunctions'
import { APP_CONSTANTS } from 'src/consumer/constants'
import helpCenterCategories from './helpCenterCategories.json'

const BreadcrumbContainer = styled.div`
  max-width: 1400px;
  margin: 24px auto 0;
  padding: 0 24px;
  @media (min-width: 768px) {
    padding: 0 32px;
    margin-top: 32px;
  }
`

const StyledBreadcrumbs = styled(Breadcrumbs)`
  .MuiBreadcrumbs-ol {
    align-items: center;
  }
  
  .MuiBreadcrumbs-li {
    a {
      color: #667eea;
      text-decoration: none;
      font-weight: 500;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 4px;
      transition: color 0.2s;
      
      &:hover {
        color: #764ba2;
        text-decoration: underline;
      }
    }
    
    &:last-child {
      color: #6b7280;
      font-weight: 500;
      font-size: 14px;
    }
  }
  
  .MuiBreadcrumbs-separator {
    color: #9ca3af;
    margin: 0 8px;
  }
`

export default function HelpCenterCategoryPage({ embedded }) {
  const { categoryId } = useParams()
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('login')
  const currentCategory =
    helpCenterCategories.find((category) => category.faqCategoryId === categoryId) || null
  
  const helpCenterPath = Boolean(embedded) ? '/help-center-embedded' : '/help-center'
  
  return (
    <>
      {Boolean(embedded) ? (
        <></>
      ) : (
        <PublicAppHeader
          config={{ showLinks: true }}
          loginFunction={() => {
            setTypeOfClubbedAuthModal('login')
            setShowClubbedAuthModal(true)
          }}
          registerFunction={() => {
            setTypeOfClubbedAuthModal('signup')
            setShowClubbedAuthModal(true)
          }}
        />
      )}
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => setShowClubbedAuthModal(false)}
        loginVariant={typeOfClubbedAuthModal === 'login'}
      />
      <SEOComponent
        title={
          currentCategory?.heading
            ? `${currentCategory.heading} Help | AUMHUM`
            : 'Help Center Category | AUMHUM'
        }
        description={
          currentCategory?.description ||
          'Browse answers and guidance from the AUMHUM Help Center.'
        }
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['help center', 'support', currentCategory?.heading || 'faq']}
      />
      <BreadcrumbContainer>
        <StyledBreadcrumbs
          separator={<ChevronRightIcon fontSize="small" />}
          aria-label="breadcrumb navigation"
        >
          <Link to={helpCenterPath}>
            <HomeIcon sx={{ fontSize: 18 }} />
            Help Center
          </Link>
          <Typography color="text.secondary">{currentCategory?.heading || 'Category'}</Typography>
        </StyledBreadcrumbs>
      </BreadcrumbContainer>
      <Box sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 3, md: 4 }, pt: 3, pb: 1 }}>
        <Typography component="h1" sx={{ fontSize: { xs: 28, md: 40 }, fontWeight: 700, mb: 1 }}>
          {currentCategory?.heading || 'Help Center Category'}
        </Typography>
        <Typography sx={{ fontSize: 16, color: '#4b5563', maxWidth: 900 }}>
          {currentCategory?.description || 'Find answers and guidance from the AUMHUM Help Center.'}
        </Typography>
      </Box>
      <FaqSection categoryIds={[categoryId]} layoutType={FAQ_LAYOUTS.TWO_COLUMN_SIDEBAR} />
    </>
  )
}
